let eventListenerAdded = false;

function initializeEventDate() {
	const eventDateElement = this.currentStepElement.querySelector('input[name="event_start_date"]');

	// Create a jQuery version of this object for use with the
	// Bootstrap datepicker we use.
	const $eventDateElement = $(eventDateElement);

	// Initialize datepicker on our event date input
	$eventDateElement.datepicker({
		format: 'mm/dd/yyyy',
		startDate: '0d',
		disableTouchKeyboard: true,
		autoclose: true,
		maxViewMode: 2, // Don't allow for "zooming out" to any time period greater than years
		todayHighlight: true
	});

	if (!eventListenerAdded) {
		// Use a new variable since our function below will have its
		// `this` value equal to the `$eventDateElement` jQuery object.
		const form = this.formElement;
		$eventDateElement.on('changeDate', (event) => {
			// We want to trigger a `change` event here to avoid
			// inaccurate error state around our input. This is
			// necessary since we're ignoring the `focusout` on this
			// input via `data-ignore-event` because of how the
			// datepicker works: it causes `focusout` to happen _after_
			// a date has been picked but _before_ the input has been
			// updated to contain the picked date. If we don't ignore
			// `focusout` then we'll see an error flicker and then
			// disappear.
			let changeEvent = new Event('change');
			form.dispatchEvent(changeEvent);
		});

		eventListenerAdded = true;
	}
}

export {
	initializeEventDate
}